import {configSchema} from './config.schema';

export const config = configSchema.parse(import.meta.env);
